import { action, observable, reaction, spy } from 'mobx';
import AuthStore from './authStore';
import UtilsStore from '@/store/utilsStore';
import DoctorStore from '@/store/DoctorStore';
import OnboardStore from './onboard/onboard';
import EngineStore from '@/store/engineStore';
import ProductStore from '@/store/ProductStore';
import LeroyStore from '@/store/leroy/LeroyStore';
import PrescriptionStore from '@/store/prescriptionStore';
import OrderStore from '@/store/orderStore';
import BiometricStore from '@/store/biometricStore';
import AgentStore from '@/store/agentStore';
import PatientStore from '@/store/patientStore';

export class Store {
	auth: AuthStore;
	utils: UtilsStore;
	doctor: DoctorStore;
	onboard: OnboardStore;
	engine: EngineStore;
	product: ProductStore;
	prescription: PrescriptionStore;
	leroy: LeroyStore;
	order: OrderStore;
	biometric: BiometricStore;
	agent: AgentStore;
	redirectUri: string;
	_patient: PatientStore;
	@observable operatorName = '';
	@observable lastRoute = '';
	@observable currentRoute = '';
	@observable pdfPopupVisible = false;
	@observable online = true;

	@observable rebooting = false;

	@observable emptyString = '';

	private engineFactory;
	private checking = false;

	constructor() {
		// NOTE: This comes from an old patch PODAPP-2047 commit hash 851409f1
		//   probably not in use anymore. Removing.
		// if (window.location.href.includes('landmark')) {
		// 	opts.redirectUri = window.location.href;
		// }
		this.redirectUri = opts.redirectUri;

		this.engine = new EngineStore(opts, this);

		this.auth = new AuthStore(
			{
				operatorClientID: window.appConfig.VUE_APP_ENGINECLIENTID,
				customerClientID: window.appConfig.VUE_APP_CUSTOMERCLIENTID,
				engine: this.engine
			},
			this
		);
		this.doctor = new DoctorStore(this);

		this._patient = new PatientStore(this);
		this.leroy = new LeroyStore(this, opts.platformURL);
		this.biometric = new BiometricStore(this);
		this.order = new OrderStore(this);
		this.utils = new UtilsStore(this);
		this.agent = new AgentStore(this);
		this.onboard = new OnboardStore();
		this.product = new ProductStore(this);
		this.prescription = new PrescriptionStore(this);
		window.addEventListener('offline', (e) => {
			this.online = false;
		});
		window.addEventListener('online', (e) => {
			this.online = true;
		});

		if (process.env.NODE_ENV !== 'production') {
			spy((evt) => {
				let oldValue, newValue;
				try {
					oldValue = JSON.parse(JSON.stringify(evt.oldValue));
				} catch (e) {
					oldValue = JSON.stringify(evt.oldValue);
				}
				try {
					newValue = JSON.parse(JSON.stringify(evt.newValue));
				} catch (e) {
					newValue = JSON.stringify(evt.newValue);
				}
				if (evt.type === 'update') {
					console.log(`%c[${evt.name.replace(/@[0-9]+/g, '')}.${evt.key}]\n%o→%o`, 'font-weight: 800; color: green', oldValue, newValue);
				}
			});
		}

		reaction(
			() => this.online,
			(o) => {
				if (!o) {
					// alert('Please check your internet connection');
				}
			}
		);

		this.checkOnline = this.checkOnline.bind(this);

		// TODO: investigate this
		// setInterval(this.checkOnline, 6000);
	}

	async checkOnline() {
		if (this.checking) {
			return;
		}

		this.checking = true;
		let timeout = 0;

		this.online = await new Promise(async (r) => {
			timeout = setTimeout(() => r(false), 5500);
			await fetch('/check.txt' + '?' + Math.floor(Math.random() * 1000000))
				.then((_) => r(_.ok))
				.catch((_) => r(false));
		});
		if (timeout) {
			clearTimeout(timeout);
		}

		this.checking = false;
	}
}

const opts = {
	engineClientID: window.appConfig.VUE_APP_ENGINECLIENTID,
	customerClientID: window.appConfig.VUE_APP_CUSTOMERCLIENTID,
	authorizationUri: window.appConfig.VUE_APP_AUTHORIZATIONURI,
	accessTokenUri: window.appConfig.VUE_APP_ACCESSTOKENURI,
	logoutUri: window.appConfig.VUE_APP_AUTHLOGOUTURI,
	registerUri: window.appConfig.VUE_APP_REGISTERURI,
	redirectUri: window.appConfig.VUE_APP_REDIRECTURI,
	platformURL: window.appConfig.VUE_APP_BASEPLATFORMURI
};

const store = new Store();

export default store;
